import Navbar from '@/components/feature/Navbar';
import Hero from '@/components/feature/Hero';
import CategoryGrid from '@/components/feature/CategoryGrid';
import BlogSection from '@/components/feature/BlogSection';
import StatsSection from '@/components/feature/StatsSection';
import Testimonials from '@/components/feature/Testimonials';
import CTASection from '@/components/feature/CTASection';
import Footer from '@/components/feature/Footer';
import PageSEO, { HOME_DEFAULTS } from '@/components/base/PageSEO';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://oopbuyspreadsheets.lol';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'OOPBuy Spreadsheets',
    url: `${SITE_URL}/`,
    description: 'The ultimate oopbuy spreadsheet tracking and automation system guide for ecommerce sellers.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'OOPBuy Spreadsheet Categories',
    url: `${SITE_URL}/`,
    description: 'Browse all oopbuy spreadsheet product categories including Shoes, Hoodies, T-Shirts, Jackets, and more.',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Shoes', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 2, name: 'Hoodies & Sweaters', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 3, name: 'T-Shirts', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 4, name: 'Jackets', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 5, name: 'Pants & Shorts', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 6, name: 'Headwear', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 7, name: 'Sets', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 8, name: 'Underwear', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 9, name: 'Jersey', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 10, name: 'Accessories', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 11, name: 'Bags', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 12, name: 'Belts', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 13, name: 'Perfumes', url: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 14, name: 'Other Stuff', url: `${SITE_URL}/` },
      ],
    },
  },
];

export default function Home() {
  return (
    <>
      <PageSEO data={HOME_DEFAULTS} jsonLd={homeJsonLd} />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <BlogSection />
        <StatsSection />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}